module.exports = __webpack_public_path__ + "img/09.2fea5ba5.png";